import { useEffect } from 'react'

export function CursorManager() {
	useEffect(() => {
		// Check if running in Electron
		const isElectron = window.navigator.userAgent.includes('Electron')

		if (isElectron) {
			// Use file:// protocol paths for Electron
			const basePath = window.location.href.replace('/index.html', '')

			document.documentElement.style.setProperty(
				'--cursor-mouse',
				`url("${basePath}/assets/cursor/mouse.png") 0 0, auto`
			)
			document.documentElement.style.setProperty(
				'--cursor-normal',
				`url("${basePath}/assets/cursor/cursor_normal.png") 26 25, auto`
			)
			document.documentElement.style.setProperty(
				'--cursor-clicked',
				`url("${basePath}/assets/cursor/cursor_clicado.png") 33 30, auto`
			)
		} else {
			// Use absolute paths for web (no ./ prefix)
			document.documentElement.style.setProperty(
				'--cursor-mouse',
				'url("/assets/cursor/mouse.png") 0 0, auto'
			)
			document.documentElement.style.setProperty(
				'--cursor-normal',
				'url("/assets/cursor/cursor_normal.png") 26 25, auto'
			)
			document.documentElement.style.setProperty(
				'--cursor-clicked',
				'url("/assets/cursor/cursor_clicado.png") 33 30, auto'
			)
		}
	}, [])

	return null
}
